<!--
 * @Description: 文件图标，如果是图片类型的直接展示图片缩略图
 * @Author: ljrong
 * @Date: 2024-07-16 17:57:37
 * @LastEditors: ljrong jinrong.li@beautydata.ai
 * @LastEditTime: 2024-07-25 17:41:04
-->
<script lang="ts" setup>
import { getFileType } from '@/utils/tool'
const props = defineProps({
  url: {
    type: String,
    required: true
  },
  size: {
    type: Number,
    default: 30
  },
})

const fileType = computed(() => {
  return getFileType(props.url)
})

const isImage = computed(() => {
  return getFileType(props.url) === 'image'
})

</script>
<template>
  <div class="file-thumbnail" :class="fileType" :style="{ width: size + 'px', height: size + 'px' }">
    <NImage v-if="isImage" :src="url" preview-disabled object-fit="cover">
    </NImage>
  </div>
</template>

<style lang="scss" scoped>
.file-thumbnail {
  display: inline-block;
  background-size: cover;
  flex-shrink: 0;

  &.pdf {
    background-image: url("https://materialdb.zhaoyl.com/fed/cowork/file-icon/pdf.png");
  }

  &.word {
    background-image: url("https://materialdb.zhaoyl.com/fed/cowork/file-icon/word.png");
  }

  &.ppt {
    background-image: url("https://materialdb.zhaoyl.com/fed/cowork/file-icon/ppt.png");
  }

  &.excel {
    background-image: url("https://materialdb.zhaoyl.com/fed/cowork/file-icon/excel.png");
  }

  &.unknown {
    background-image: url("https://materialdb.zhaoyl.com/fed/cowork/file-icon/unknow.png");
  }
}
</style>